import {createContext, useState} from "react";

export const CheckpointsListContext = createContext({checkpointsList: [], setCheckpointsList: () => {}});

const CheckpointsListProvider = ({children}) => {
    const [checkpointsList, setCheckpointsList] = useState([]);

    const value = {checkpointsList, setCheckpointsList};

    return (
        <CheckpointsListContext.Provider value={value}>
            {children}
        </CheckpointsListContext.Provider>
    );
}

export default CheckpointsListProvider